export function is_touch_enabled() {
    return window.matchMedia("(pointer: coarse)").matches;
}